// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IResponseCipStatusDto
 */
export interface IResponseCipStatusDto {
    /**
     * 
     * @type {number}
     * @memberof IResponseCipStatusDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IResponseCipStatusDto
     */
    cip_info_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IResponseCipStatusDto
     */
    status?: IResponseCipStatusDtoStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof IResponseCipStatusDto
     */
    valid_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IResponseCipStatusDto
     */
    valid_to?: Date;
}

/**
* @export
* @enum {string}
*/
export enum IResponseCipStatusDtoStatusEnum {
    NONE = 'NONE',
    PENDING = 'PENDING',
    PASS = 'PASS',
    FAIL = 'FAIL',
    QUESTION = 'QUESTION',
    RENEWED = 'RENEWED',
    CIP_FAILED_ACCOUNT_CLOSE = 'CIP_FAILED_ACCOUNT_CLOSE'
}


/**
 * Check if a given object implements the IResponseCipStatusDto interface.
 */
export function instanceOfIResponseCipStatusDto(value: object): value is IResponseCipStatusDto {
    return true;
}

export function IResponseCipStatusDtoFromJSON(json: any): IResponseCipStatusDto {
    return IResponseCipStatusDtoFromJSONTyped(json, false);
}

export function IResponseCipStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IResponseCipStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'cip_info_id': json['cip_info_id'] == null ? undefined : json['cip_info_id'],
        'status': json['status'] == null ? undefined : json['status'],
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'valid_to': json['valid_to'] == null ? undefined : (new Date(json['valid_to'])),
    };
}

export function IResponseCipStatusDtoToJSON(json: any): IResponseCipStatusDto {
    return IResponseCipStatusDtoToJSONTyped(json, false);
}

export function IResponseCipStatusDtoToJSONTyped(value?: IResponseCipStatusDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'cip_info_id': value['cip_info_id'],
        'status': value['status'],
        'valid_from': value['valid_from'] == null ? undefined : ((value['valid_from']).toISOString()),
        'valid_to': value['valid_to'] == null ? undefined : ((value['valid_to']).toISOString()),
    };
}

